<div class="modal-header">
    <!-- ### show filter icon -->
    <i *ngIf="modal" class="fas fa-filter"></i>
    <h5 *ngIf="title" class="modal-title">{{title | sqMessage}}</h5>
    <ng-content></ng-content>
    <button type="button" class="btn-close" (click)="cancel()" data-dismiss="modal" aria-hidden="true"></button>
</div>
